import React from 'react';
import { reduxForm, Field } from 'redux-form';

// Components
import TextField from '../../../../shared/components/form/TextField';
import ContactPickerField from './ContactPickerField';

const CreateContactGroupForm = () => (
  <form className="material-form form--horizontal text-left">
    <div className="form__form-group w-25">
      <span className="form__form-group-label">Name</span>
      <Field
        className="material-form__field"
        name="name"
        component={TextField}
      />
    </div>
    <hr />
    <div className="form__form-group">
      <Field
        className="material-form__field"
        name="contacts"
        component={ContactPickerField}
      />
    </div>
  </form>
);

const withForm = {
  form: 'contactGroupForm',
};

export default reduxForm(withForm)(CreateContactGroupForm);
